import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { PackageModulesFormDataProviderFactory } from '../factory/PackageModulesFormDataProviderFactory';
import { PackageModulesFormBaseDataProvider } from '../dataProvider/PackageModulesFormBaseDataProvider';
import { OperationModeData } from '../../../types/operation-mode-data';

export class PackageModulesFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PackageModulesFormDataProviderFactory;
  public dataProvider: PackageModulesFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PackageModulesFormDataProviderFactory(),
    });
  }

  public getOperationModes(): OperationModeData[] {
    return this.dataProvider.getOperationModes();
  }
}
